import {ActionService} from "../../../../../opportunity_actions_service/service/ActionService";
import {EmailActionComponent, EmailActionScope} from "../EmailAction";
import {ToastNotificationService} from "../../../../../utils/ToastNotificationService";
import {ActionComponent} from "../../action.component";
import {Opportunity} from "../../../../../opportunities/model/Opportunity";
import {ActionTypes} from "../../../../../action_status/model/ActionType";
import {UserGranredAuthorityName} from "modules/router/const/AllPermitions";

interface AgentEmailActionScope extends EmailActionScope {
}

export class EmailAgentAction extends EmailActionComponent {

    protected $scope: AgentEmailActionScope;

    static instance = () => ActionComponent.instance(EmailAgentAction);

    constructor($scope: AgentEmailActionScope,
                actionService: ActionService,
                $exceptionHandler: ng.IExceptionHandlerService,
                $mdDialog: angular.material.IDialogService,
                toastService: ToastNotificationService) {
        super($scope, actionService, $exceptionHandler, $mdDialog, toastService);
    }

    protected getActionType = () => ActionTypes.EMAIL_AGENT;

    protected getTitle = () => "Email Loan Officer";

    protected getIcon = () => "/app/images/icons/mail.svg";

    protected isDisabled(opportunity: Opportunity): boolean {
        //everything except Epo thing
        return (!this.hasAccessToEmployeeEmail()) || ((!opportunity.customer.employee) ||
            (!opportunity.customer.employee.active) ||
            (!opportunity.customer.employee.licensed));
    }

    private hasAccessToEmployeeEmail(): boolean {
        return  this.principle.userAccessLevels.find(f => f.authorityName == UserGranredAuthorityName.OPPORTUNITY_EMPLOYEE_MAILING).status
    }

}